import React from "react";
import Table from "../../../components/Table";
import { VermogensRekening } from "../../../../../.generated/rapportage/rapportagetypes";
import { getVermogenColumns } from "../../Producten/vermogen-kolommen";

export interface SingleVermogenTableProps {
  data: VermogensRekening;
}

export interface VermogenTableProps {
  data: VermogensRekening[];
}

export const SingleVermogenTable: React.FC<SingleVermogenTableProps> = ({
  data,
}: SingleVermogenTableProps) => {
  return (
    <div className="mb-4">
      <Table
        columns={getVermogenColumns(data.soortProduct ?? "", true)}
        data={[data]}
        rotate={true}
        showHeader={true}
        filterNullAnd0Columns={true}
        id={`vermogen-table-${data.productnaam
          ?.replace(/\s+/g, "-")
          .toLowerCase() || "vermogen"}`}
      />
    </div>
  );
};

export const VermogenTable: React.FC<VermogenTableProps> = ({
  data,
}: VermogenTableProps) => {
  return (
    <div className="vermogen-section">
      {data.map((vermogen, index) => (
        <SingleVermogenTable key={index} data={vermogen} />
      ))}
    </div>
  );
};
